import { SearchTerm } from "./SearchTerm";

const GeneralAccessReportSearch: SearchTerm[] = [
    {
        heading: "All",
        accessor: "search",
        searchOnName: "search",
        translationKey: "all"
    },
    {
        heading: "Display Name",
        accessor: "displayName",
        searchOnName: "mstDisplayname",
        translationKey: "displayName"
    }
];

export default GeneralAccessReportSearch;
